import { referenceDataService } from './referenceData';

import { KMFC_DOCUMENT_MAIL_SERVICE, KMFC_MAIL_SERVICE, KMFC_REFERENCE_DATA } from '../../../actions/kaMetlhaFuneralClaim/referenceData';
import { claimMailService } from './claimMailService';
import { uploadDocumentMailService } from './uploadDocumentMailService';

export const kaMetlhaFuneralClaimServices = (store, next, action) => {
    // if (action.type===DLP_CONFIRM_DETAILS_SUBMIT_APPLICATION_SEND){
    //     return submitDlpApplicationService(store, next, action);
    //   }
    if (action.type.startsWith(KMFC_REFERENCE_DATA)) return referenceDataService(store, next, action);
    if (action.type.startsWith(KMFC_MAIL_SERVICE)) return claimMailService(store, next, action);
    if (action.type.startsWith(KMFC_DOCUMENT_MAIL_SERVICE)) return uploadDocumentMailService(store, next, action);

    return null;
};
